export default "__VITE_ASSET__Bml0V$fW__"